export const navLinks = [
  { label: '首页', href: '/' },
  { label: '豪门资源', href: '/category/resources' },
  { label: '商务合作', href: '/category/business' },
  { label: '精英社交', href: '/category/social' },
  { label: '国际投资', href: '/category/investment' },
  { label: '关于我们', href: '/about' },
];

export const heroData = {
  title: '豪门国际',
  subtitle: '通往顶级国际资源的首选平台',
  description: '汇聚全球豪门资源、高端商务合作与精英社交圈层，助您跨越国际边界，实现财富与地位的双重跃升。',
  cta: '立即了解豪门国际',
  ctaSecondary: '探索更多资源',
};

export const servicesData = [
  {
    id: 's1',
    icon: 'ri-global-line',
    title: '全球豪门资源对接',
    description: '汇聚全球顶级豪门家族资源，为您精准匹配高端人脉、稀缺项目与优质机会，助力您在全球化浪潮中抢占先机。',
  },
  {
    id: 's2',
    icon: 'ri-shake-hands-line',
    title: '高端商务合作',
    description: '搭建国际商务合作桥梁，连接全球顶尖企业与投资机构，推动跨国项目落地，实现商业价值的最大化。',
  },
  {
    id: 's3',
    icon: 'ri-vip-crown-line',
    title: '精英社交圈层',
    description: '打造专属精英社交平台，定期举办高端私享活动，让您与志同道合的全球精英建立深度联系。',
  },
  {
    id: 's4',
    icon: 'ri-funds-line',
    title: '国际投资顾问',
    description: '提供专业的国际投资咨询与财富管理服务，由资深顾问团队为您量身定制全球资产配置方案。',
  },
  {
    id: 's5',
    icon: 'ri-government-line',
    title: '政商关系桥梁',
    description: '构建政商沟通渠道，协助处理跨国事务、政策咨询与国际关系协调，为您的国际业务保驾护航。',
  },
  {
    id: 's6',
    icon: 'ri-graduation-cap-line',
    title: '精英教育规划',
    description: '对接全球顶尖教育资源，为高端家庭提供子女海外名校申请、贵族教育规划与综合素质培养方案。',
  },
];

export const categoriesData = [
  {
    slug: 'resources',
    name: '豪门资源',
    description: '全球顶级家族资源、稀缺项目与优质机会',
    count: 128,
  },
  {
    slug: 'business',
    name: '商务合作',
    description: '跨国企业合作、投资并购与商业对接',
    count: 96,
  },
  {
    slug: 'social',
    name: '精英社交',
    description: '高端私享活动、圈层聚会与国际交流',
    count: 84,
  },
  {
    slug: 'investment',
    name: '国际投资',
    description: '全球资产配置、财富管理与投资顾问',
    count: 72,
  },
  {
    slug: 'education',
    name: '精英教育',
    description: '海外名校申请、贵族教育与综合素质培养',
    count: 56,
  },
  {
    slug: 'lifestyle',
    name: '品质生活',
    description: '高端定制旅行、奢侈品鉴赏与生活方式',
    count: 64,
  },
];

export const partnersData = [
  { name: '瑞士瑞银集团', slug: 'ubs' },
  { name: '摩根士丹利', slug: 'morgan-stanley' },
  { name: '汇丰银行', slug: 'hsbc' },
  { name: '黑石集团', slug: 'blackstone' },
  { name: '麦肯锡咨询', slug: 'mckinsey' },
  { name: '佳士得拍卖行', slug: 'christies' },
  { name: '劳斯莱斯汽车', slug: 'rolls-royce' },
  { name: '苏富比国际', slug: 'sothebys' },
];

export const statsData = [
  { label: '全球合作伙伴', value: '500+', suffix: '家' },
  { label: '精英会员', value: '12,800', suffix: '位' },
  { label: '覆盖国家', value: '60+', suffix: '个' },
  { label: '成功案例', value: '3,200', suffix: '例' },
];

export const newsData = [
  {
    slug: 'global-elite-summit-2026',
    title: '2026全球精英峰会成功举办，豪门国际引领行业新风向',
    excerpt: '由豪门国际主办的2026全球精英峰会于上海圆满落幕，来自全球30多个国家和地区的500余位顶级企业家、投资人与社会名流齐聚一堂。',
    category: '精英社交',
    date: '2026-07-28',
    imageSeq: 'news-summit-2026',
    featured: true,
  },
  {
    slug: 'cross-border-investment-opportunities',
    title: '豪门国际发布2026下半年跨境投资机遇报告',
    excerpt: '报告深度分析了全球宏观经济走势，重点解读了东南亚新兴市场、欧洲高端地产与中东能源转型三大投资主题。',
    category: '国际投资',
    date: '2026-07-20',
    imageSeq: 'news-investment-2026',
  },
  {
    slug: 'luxury-lifestyle-club-launch',
    title: '豪门国际高端品质生活俱乐部正式启动',
    excerpt: '俱乐部将为会员提供全球顶级酒店私享价、私人飞机包机服务、限量版奢侈品优先购买权等多项专属权益。',
    category: '品质生活',
    date: '2026-07-15',
    imageSeq: 'news-lifestyle-club',
  },
  {
    slug: 'education-elite-program',
    title: '豪门国际与英国伊顿公学达成战略合作',
    excerpt: '双方将在精英教育领域展开深度合作，为豪门国际会员子女提供专属入学咨询、暑期精英课程与定制化教育方案。',
    category: '精英教育',
    date: '2026-07-08',
    imageSeq: 'news-education-eton',
  },
];

export const faqData = [
  {
    question: '如何成为豪门国际的会员？',
    answer: '我们采用邀请制与推荐制相结合的会员准入模式。您可以通过现有会员推荐，或直接联系我们的客户关系团队提交入会申请。我们会根据申请人的社会影响力、商业成就与个人信誉进行综合评估。',
  },
  {
    question: '豪门国际的核心服务区域包括哪些？',
    answer: '我们的服务网络覆盖亚洲、欧洲、北美、中东及澳洲等60多个国家和地区，在香港、上海、新加坡、伦敦、纽约、迪拜等国际金融中心均设有联络处与合作机构。',
  },
  {
    question: '豪门国际如何保障会员隐私与信息安全？',
    answer: '我们采用银行级别的信息加密技术，所有会员资料均存储于独立安全服务器，遵循最严格的隐私保护协议。我们承诺绝不向第三方透露任何会员信息，这也是我们赢得全球精英信赖的基石。',
  },
  {
    question: '是否可以帮助对接特定的商业资源或投资项目？',
    answer: '当然可以。我们的专业顾问团队会根据您的具体需求，利用全球资源网络进行精准匹配，涵盖房地产、金融科技、新能源、医疗健康、文化艺术等多个领域，并提供全程对接服务。',
  },
  {
    question: '豪门国际有哪些定期举办的线下活动？',
    answer: '我们定期举办全球精英峰会、行业闭门研讨会、高端社交晚宴、私人艺术鉴赏会、海外投资考察团等多元化活动。会员可根据自身兴趣与需求自由选择参与，部分高端活动采用限量预约制。',
  },
  {
    question: '会员费用如何收取？是否有不同等级？',
    answer: '我们设有铂金会员、钻石会员与黑金会员三个等级，不同等级享有差异化的服务内容与专属权益。具体费用根据会员需求与服务范围定制，请联系我们的客户关系团队获取详细信息。',
  },
  {
    question: '豪门国际是否提供中文服务？',
    answer: '我们的全球团队精通中、英、法、德、日、阿拉伯语等多种语言，确保为华人精英提供无缝的中文服务体验，同时协助处理跨文化、跨语言的国际商务事务。',
  },
];

export const aboutData = {
  brandName: '豪门国际',
  brandIntro: '豪门国际创立于2010年，总部位于香港，是全球领先的高端资源整合平台。我们致力于为全球高净值人群与精英阶层提供顶级的国际资源对接、高端商务合作与精英社交服务。',
  mission: '连接全球精英，赋能无界合作，以专业与信任重塑国际高端资源生态。',
  vision: '成为全球最受信赖的高端资源整合平台，让每一位精英都能跨越国界，实现财富与影响力的最大化。',
  values: [
    { title: '信任至上', description: '以最严格的隐私保护与诚信标准，赢得全球精英的信赖' },
    { title: '全球化视野', description: '立足亚洲，放眼全球，连接世界各地的顶级资源与机会' },
    { title: '精准匹配', description: '通过专家团队与智能算法，实现资源与人脉的精准高效对接' },
    { title: '长期主义', description: '关注长期价值创造，陪伴每一位会员实现可持续的成功' },
  ],
  reputation: [
    { title: '全球精英峰会年度最佳平台', year: '2025', org: '国际精英联盟' },
    { title: '亚太区最具影响力资源整合品牌', year: '2024', org: '亚洲商业评论' },
    { title: '最佳高端社交平台奖', year: '2024', org: '奢侈品产业协会' },
    { title: '年度跨境投资顾问机构', year: '2023', org: '全球财富管理论坛' },
    { title: '卓越服务品质认证', year: '2023', org: '国际品质服务协会' },
    { title: '行业创新引领奖', year: '2022', org: '全球商业领袖峰会' },
  ],
  contact: {
    address: '香港中环金融街8号国际金融中心二期68楼',
    phone: '+852 2888 8888',
    email: 'contact@haomeninternational.com',
    wechat: 'Haomen_International',
    workingHours: '周一至周五 09:00 - 18:00',
  },
};

export const footerData = {
  company: '豪门国际',
  slogan: '通往顶级国际资源的首选平台',
  quickLinks: [
    { label: '豪门资源', href: '/category/resources' },
    { label: '商务合作', href: '/category/business' },
    { label: '精英社交', href: '/category/social' },
    { label: '国际投资', href: '/category/investment' },
    { label: '关于我们', href: '/about' },
  ],
  services: [
    { label: '资源对接', href: '/category/resources' },
    { label: '投资顾问', href: '/category/investment' },
    { label: '社交活动', href: '/category/social' },
    { label: '教育规划', href: '/category/education' },
    { label: '品质生活', href: '/category/lifestyle' },
  ],
  contact: {
    address: '香港中环金融街8号国际金融中心二期68楼',
    phone: '+852 2888 8888',
    email: 'contact@haomeninternational.com',
  },
};